export default __webpack_public_path__ + "static/media/canteen-2.fa174570.jpg";